import React, { useState, useEffect } from "react";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Col,
  Typography,
  Form,
  Card,
  Divider,
  Button,
  Modal,
  Checkbox,
  Table,
} from "antd";

//PROJECT IMPORTS
import appLabel from "../../../../../config/appLabel";
import appStatic from "../../../../../config/appStatic";

const { Text, Title } = Typography;

export default function InterestChartRateForm({ redeDetail }) {
  const [useForm] = Form.useForm();

  const columnOne = [
    {
      title: "Period From / To",
      dataIndex: "periodFromTo",
    },
    {
      title: "Amount Range From",
      dataIndex: "amountRangeFrom",
    },
    {
      title: "Amount Range To",
      dataIndex: "amountRangeTo",
    },
    {
      title: "Interest",
      dataIndex: "interest",
    },
    {
      title: "Description",
      dataIndex: "description",
    },

    {
      title: "",
      dataIndex: "incentives",
      width: "2%",
      render: () => (
        <Button type="link" onClick={showModal} style={{ color: "#92428B" }}>
          Incentives
        </Button>
      ),
    },
  ];

  const [showAdvanced, setShowAdvanced] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [chartDetail, setChartDetail] = useState([]);
  useEffect(() => {
    let tempArray = [];
    redeDetail?.activeChart?.chartSlabs.forEach((element) => {
      tempArray.push({
        key: element?.id,
        periodFromTo: element?.fromPeriod
          ? `${element?.fromPeriod} - ${element?.periodType?.value}`
          : "-",
        amountRangeFrom: element?.amountRangeFrom
          ? Number(element?.amountRangeFrom).toLocaleString()
          : "-",
        amountRangeTo: element?.amountRangeTo
          ? Number(element?.amountRangeTo).toLocaleString()
          : "-",
        interest: element?.annualInterestRate
          ? element?.annualInterestRate
          : "-",
        description: element?.description ? element?.description : "-",
      });
    });
    setChartDetail(tempArray);
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCheckboxChange = (e) => {
    setShowAdvanced(e.target.checked);
    console.log(e.target.checked);
  };
  const { monthList } = appStatic;
  const fromDate = `${redeDetail?.activeChart?.fromDate[2]} ${
    monthList[redeDetail?.activeChart?.fromDate[1] - 1]
  } ${redeDetail?.activeChart?.fromDate[0]}`;

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        }}
      >
        <Title level={4}>Interest Rate Chart</Title>
        <Divider style={{ margin: 0, padding: 0 }} />
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Valid Start Date</Text>}
              rules={[
                {
                  required: true,
                  message: "Required Field",
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={fromDate}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text strong>End Date</Text>}>
              <Input className="of-bold-disable-input" disabled value={""} />
            </Form.Item>
          </Col>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text strong>Is Primary Grouping By Amount</Text>}
            >
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.activeChart?.isPrimaryGroupingByAmount
                    ? "Yes"
                    : "No"
                }
              />
            </Form.Item>
          </Col>
        </Row>

        <Modal
          title="Incentives"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          closeIcon={false}
          width={1000}
          footer={[
            <Row align={"right"}>
              <Button
                onClick={handleCancel}
                key="back"
                style={{
                  marginLeft: "auto",
                  marginBottom: "12px",
                  width: "15%",
                  height: "15%",
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  //   borderRadius: 20
                }}
              >
                {" "}
                Close
              </Button>
            </Row>,
          ]}
        >
          <Title level={4}>Customer Attributes</Title>
          <Divider style={{ margin: 10, padding: 0 }} />
          <Table
            columns={columnOne}
            // columns={columns}
            // dataSource={chartDetail}
            bordered
            pagination={{
              position: "bottomCentre",
            }}
          />
        </Modal>
        <div>
          <Table
            columns={columnOne}
            dataSource={chartDetail}
            bordered
            pagination={{
              position: "bottomCentre",
            }}
          />
        </div>
      </Card>
    </Form>
  );
}
